import { IPlan } from "../../../../common/types";
import { PlanActionTypes } from "../models/planActions";
import { SET_EXPERIENCE } from "../types";

export default (data: IPlan["experience"]): PlanActionTypes => ({
    type: SET_EXPERIENCE,
    payload: data,
});
